class CartGiftBox {
  constructor(container) {
    this.initEvents();
    this.synchronousGifts();
    // 状态控制
    this.isHandlingCart = false;
    setTimeout(() => {
      this.init();
    }, 0);
  }
  init() {
    this.cart_gift_box = document.querySelector(".cart-gift-box");
    this.cart_gift_title = document.querySelector(
      ".cart-gift-box .cart-gift-box-title"
    );
    this.cartPop_up = document.querySelector(
      ".cart-gift-box .cart-gift-box-pop-up"
    );
    this.cartPop_up_close = document.querySelector(
      ".cart-gift-box-pop-up .svg-wrapper"
    );
    this.addBtn = document.querySelectorAll(
      ".cart-gift-box-pop-up .cart-gift-box-pop-up-content-product-item-buy"
    );
    this.cart_gift_title?.addEventListener("click", () => {
      this.switchPopUp(this.isSowTileText);
      this.isSowTileText = false;
    });
    this.cartPop_up_close?.addEventListener("click", () => {
      this.switchPopUp(false);
      this.isSowTileText = true;
    });
    this.addBtn?.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        item.querySelector('.loading__spinner').classList.remove("hidden");
        this.select_value = item.parentNode.querySelector("select");
        let productId = e.target.getAttribute("id");
        let size = e.target.getAttribute("size");
        this.addToCart(productId, size);
      });
    });
  }
  refreshCartUI = async () => {
    document
      .querySelector("form.cart__contents input.quantity__input")
      .dispatchEvent(new Event("change", { bubbles: true }));
  };
  // 增强版添加方法
  addToCart = async (variantId, size) => {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: size
              ? {
                  _selected_gifts: "true",
                  "Bracelet Size": this.select_value.value + "cm",
                }
              : {
                  _selected_gifts: "true",
                },
          },
        ],
      }),
    });

    const result = await response.json();
    this.refreshCartUI();
    this.switchPopUp(false);
    // return result;
  };
  //展示隐藏弹窗
  switchPopUp = (flag) => {
    if (flag) {
      document.body.appendChild(this.cartPop_up);
      this.cartPop_up.classList.replace(
        "cart-gift-box-pop-up-hidden",
        "cart-gift-box-pop-up-show"
      );
    } else {
      this.cart_gift_box.appendChild(this.cartPop_up);
      this.cartPop_up.classList.replace(
        "cart-gift-box-pop-up-show",
        "cart-gift-box-pop-up-hidden"
      );
      this.cartPop_up.remove();
    }
  };
  fetchCart = async () => {
    const response = await fetch("/cart.js");
    return response.json();
  };
  // 更可靠的事件监听
  initEvents = () => {
    // 标准化事件监听
    const safeHandler = debounce(() => this.synchronousGifts(), 1000);

    // 兼容多种主题事件
    const events = [
      "ajaxCart:afterAdd",
      "ajaxCart:afterUpdate",
      "ajaxCart:afterRemove",
      "cart:updated",
      "cart:change",
      "cart:requestComplete",
    ];

    events.forEach((event) => {
      document.addEventListener(event, safeHandler);
    });

    // 表单提交兜底
    document.addEventListener("submit", (e) => {
      if (e.target.action?.match(/\/cart\/(add|change|update)/)) {
        safeHandler();
      }
    });

    // 拦截fetch/XHR请求（兜底方案）
    this.interceptCartRequests();
  };
  // 新增：请求拦截器
  interceptCartRequests = () => {
    const originalFetch = window.fetch;
    window.fetch = async (input, init) => {
      const res = await originalFetch(input, init);
      if (typeof input === "string" && input.includes("/cart/change")) {
        setTimeout(async () => {
          await this.synchronousGifts();
          this.init();
        }, 1000);
      }
      return res;
    };
  };
  // 增强版移除方法
  async removeFromCart(lineItemKey) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0,
        properties: null, // 清除可能存在的属性
      }),
    });
    const result = await response.json();
    return result;
  }
  synchronousGifts = async () => {
    //return;
    if (this.isHandlingCart) {
      return;
    }
    this.isHandlingCart = true;
    try {
      let cart = await this.fetchCart();
      if (!cart) {
        return;
      }

      const hasMainItems = cart.items.some(
        (item) =>
          !item?.properties?._selected_gifts && !item.properties._auto_gift
      );
      const packagingItem = cart.items.find(
        (item) => item?.properties?._selected_gifts
      );
      if (!hasMainItems && packagingItem) {
        this.showCartGiftTitle("show");
        this.isSowTileText = true;
        await this.removeFromCart(packagingItem.key);
      } else if (hasMainItems && packagingItem) {
        this.showCartGiftTitle("hide");
        this.isSowTileText = false;
      } else if (hasMainItems && !packagingItem) {
        this.showCartGiftTitle("show");
        this.isSowTileText = true;
      } else {
        this.showCartGiftTitle("none");
        this.isSowTileText = false;
      }
    } catch (error) {
      console.error("AutoPackaging 错误:", error);
    } finally {
      this.isHandlingCart = false;
    }
  };
  //标题展示
  showCartGiftTitle = (flag) => {
    let beforeTitle = document.querySelector(
      ".cart-gift-box-title-text-before"
    );
    if (flag == "show") {
      beforeTitle && (beforeTitle.style.display = "flex");
      document.querySelector(".cart-gift-box-title-text-before1") &&
        (document.querySelector(
          ".cart-gift-box-title-text-before1"
        ).style.display = "flex");
      document.querySelector(".cart-gift-box-title-text-after") &&
        (document.querySelector(
          ".cart-gift-box-title-text-after"
        ).style.display = "none");
    } else if (flag == "hide") {
      beforeTitle && (beforeTitle.style.display = "none");
      document.querySelector(".cart-gift-box-title-text-before1") &&
        (document.querySelector(
          ".cart-gift-box-title-text-before1"
        ).style.display = "none");
      document.querySelector(".cart-gift-box-title-text-after") &&
        (document.querySelector(
          ".cart-gift-box-title-text-after"
        ).style.display = "flex");
    } else {
      document.querySelector(".cart-gift-box-title") &&
        (document.querySelector(".cart-gift-box-title").style.display = "none");
    }
  };
}
let cartGiftBox = new CartGiftBox();
